import React from "react";
import { Collapse, Button } from "antd";
import Loginheader from "./loginheader/Loginheader";
import Footer from "./footer/Footer";

const { Panel } = Collapse;

const faqs = [
  {
    q: "How do I track employee attendance?",
    a: "Open the BEMSS app → Go to Attendance → Select date → View attendance report.",
    icon: "📋",
  },
  {
    q: "How do I Check in / Check Out?",
    a: "Open Camera → Select the Work Site → Capture Image Click → Check In / Check Out → Submit the process.",
    icon: "📷",
  },
  {
    q: "How do I Apply Onduty?",
    a: "Open Attendance → Click on Apply Onduty → Select Session as LIVE / PAST → If Past select the FROM – TO Date → Submit Data.",
    icon: "�",
  },
  {
    q: "How do I access reports and analytics?",
    a: "Go to the Dashboard in the BEMSS app → Select Reports → Filter by date or team.",
    icon: "📊",
  },
];

const styles = {
  wrapper: {
    maxWidth: 1400,
    margin: "0 auto",
    padding: "40px 20px 60px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#ffffff",
    minHeight: "100vh",
  },
  hero: {
    background: "linear-gradient(135deg, #1a3a6e 0%, #1565c0 55%, #1976d2 100%)",
    borderRadius: 20,
    padding: "52px 48px",
    marginBottom: 32,
    boxShadow: "0 20px 60px rgba(21,101,192,0.35)",
    position: "relative",
    overflow: "hidden",
  },
  heroBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,255,255,0.15)",
    border: "1px solid rgba(255,255,255,0.25)",
    color: "#fff",
    padding: "5px 14px",
    borderRadius: 100,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    marginBottom: 20,
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    color: "#fff",
    lineHeight: 1.2,
    marginBottom: 12,
  },
  heroSub: {
    fontSize: 16,
    color: "rgba(255,255,255,0.75)",
    fontWeight: 400,
    maxWidth: 420,
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    color: "#1565c0",
    marginBottom: 14,
  },
  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 16,
    marginBottom: 32,
  },
  contactCard: {
    background: "#fff",
    borderRadius: 14,
    padding: "24px 20px",
    border: "1.5px solid #e8edf7",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    transition: "transform 0.2s, box-shadow 0.2s, border-color 0.2s",
  },
  cardIcon: (bg) => ({
    width: 44,
    height: 44,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    marginBottom: 14,
    background: bg,
  }),
  cardTitle: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "#90a4ae",
    marginBottom: 6,
  },
  cardValue: {
    fontSize: 14,
    fontWeight: 600,
    color: "#1a2a4a",
    lineHeight: 1.5,
    whiteSpace: "pre-line",
  },
  faqSection: {
    background: "#fff",
    borderRadius: 16,
    padding: "32px 28px",
    border: "1.5px solid #e8edf7",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    marginBottom: 32,
  },
  faqPanelHeader: {
    fontWeight: 600,
    fontSize: 14,
    color: "#1a2a4a",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  faqAnswer: {
    fontSize: 14,
    color: "#546e8a",
    lineHeight: 1.7,
    paddingLeft: 28,
  },
  ctaBox: {
    background: "linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%)",
    border: "1.5px solid #bbdefb",
    borderRadius: 16,
    padding: "36px 32px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: 22,
    fontWeight: 800,
    color: "#1a3a6e",
    marginBottom: 8,
  },
  ctaSub: {
    fontSize: 14,
    color: "#546e8a",
    marginBottom: 24,
  },
};

const contactItems = [
  { icon: "✉️", bg: "#e3f2fd", label: "Email", value: "bemsssupport@bashyamgroup.com" },
  { icon: "📞", bg: "#e8f5e9", label: "Phone", value: "+91-7200641415" },
  { icon: "🕘", bg: "#fff3e0", label: "Office Hours", value: "Mon–Fri\n9:00 AM – 6:00 PM IST" },
];

export default function IosSupport() {
  return (
    <>
      <Loginheader />
      <div style={styles.wrapper}>

        {/* ── Hero ── */} 
        <div style={styles.hero}>
          <div style={styles.heroBadge}>🛡️&nbsp; Official Support</div>
          <h1 style={styles.heroTitle}>Need Help? We're Here for You!</h1>
          <p style={styles.heroSub}>
            Get answers, report issues, or reach our team directly.
            BEMSS support is always just a message away.
          </p>
        </div>

        {/* ── Contact Cards ── */}
        <p style={styles.sectionLabel}>Contact Us</p>
        <div style={styles.contactGrid}>
          {contactItems.map(({ icon, bg, label, value }) => (
            <div key={label} style={styles.contactCard}>
              <div style={styles.cardIcon(bg)}>{icon}</div>
              <div style={styles.cardTitle}>{label}</div>
              <div style={styles.cardValue}>{value}</div>
            </div>
          ))}
        </div>

        {/* ── FAQ ── */}
        <p style={styles.sectionLabel}>Frequently Asked Questions</p>
        <div style={styles.faqSection}>
          <Collapse
            accordion
            bordered={false}
            style={{ background: "transparent" }}
            expandIconPosition="end"
          >
            {faqs.map((item, i) => (
              <Panel
                key={String(i)}
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  border: "1.5px solid #e8edf7",
                  marginBottom: i < faqs.length - 1 ? 10 : 0,
                  overflow: "hidden",
                }}
                header={
                  <span style={styles.faqPanelHeader}>
                    <span style={{ fontSize: 16 }}>{item.icon}</span>
                    {item.q}
                  </span>
                }
              >
                <p style={styles.faqAnswer}>{item.a}</p>
              </Panel>
            ))}
          </Collapse>
        </div>

        {/* ── CTA Footer ── */}
        <div style={styles.ctaBox}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>💬</div>
          <h2 style={styles.ctaTitle}>Still Need Help?</h2>
          <p style={styles.ctaSub}>
            Need more help? Contact our support team anytime. We're committed to
            helping you manage your workforce efficiently.
          </p>
          <Button
            type="primary"
            size="large"
            style={{
              background: "linear-gradient(135deg, #1565c0, #1976d2)",
              border: "none",
              height: 46,
              padding: "0 36px",
              fontSize: 15,
              fontWeight: 700,
              borderRadius: 10,
              boxShadow: "0 6px 20px rgba(21,101,192,0.35)",
            }}
            onClick={() => window.open("mailto:bemsssupport@bashyamgroup.com")}
          >
            📧&nbsp; Contact Support
          </Button>
        </div>

      </div>
      <Footer />
    </>

  );
}